import React from "react";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter"; // using Twitter icon for "X"
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function HomeFooterSection() {
  return (
    <footer className="w-full bg-black text-white px-6 pt-8 pb-10">
      <div className="max-w-md mx-auto">
        {/* Logo pill */}
        <div className="rounded-3xl bg-[#071A2D] px-5 py-4 mb-6 flex flex-col items-center">
          <div className="flex items-center gap-3">
            <img
              src="/logoWhite.svg"
              alt="Intraverse"
              className="h-6 object-contain"
            />
          </div>
          <div className="mt-1 text-sm text-[#2383ff]">
            Africa’s Smartest Travel Platform
          </div>
        </div>

        {/* Contact rows */}
        <div className="space-y-4 text-sm items-center flex flex-col">
          <a
            href="tel:09030002629"
            className="flex items-center gap-3 hover:opacity-90"
          >
            <PhoneInTalkOutlinedIcon fontSize="small" className="opacity-90" />
            <span className="tracking-wide">09030002629</span>
          </a>

          <a
            href="mailto:hello@intraverse.africa"
            className="flex items-center gap-3 hover:opacity-90"
          >
            <MailOutlineOutlinedIcon fontSize="small" className="opacity-90" />
            <span className="tracking-wide">hello@intraverse.africa</span>
          </a>

          <div className="flex items-start gap-3">
            <LocationOnOutlinedIcon
              fontSize="small"
              className="mt-0.5 opacity-90"
            />
            <span className="tracking-wide">
              14b Wole Ariyo, Lekki Phase One, Lagos, Nigeria
            </span>
          </div>
        </div>

        {/* Divider */}
        <div className="my-6 h-px bg-white/15" />

        {/* Social icons */}
        <div className="flex items-center justify-evenly gap-3">
          {[
            { Icon: InstagramIcon, href: "#" },
            { Icon: FacebookIcon, href: "#" },
            { Icon: TwitterIcon, href: "#" }, // shown as "X"
            { Icon: LinkedInIcon, href: "#" },
          ].map(({ Icon, href }, i) => (
            <a
              key={i}
              href={href}
              className="grid place-items-center w-14 h-14 rounded-2xl bg-white/10 hover:bg-white/15 transition"
              aria-label="social link"
            >
              <Icon />
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center text-xs text-white/70">
          © 2025 Intraverse Africa. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default HomeFooterSection;
